module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"events":"No events | {count}/{totalCount} Events"},"no":{"events":"Ingen hendelser | {count}/{totalCount} Hendelser"}}')
  delete Component.options._Ctor
}
